export function obscureAccountNo(s) {
    if (s === undefined) {
        return '';
    }

    const origLength = s.length;
    const stars = s.slice(0, origLength - 4)
        .replace(/./g, '*');

    return stars + s.slice(origLength - 4);
}